import React from 'react';

// Secção 6 · Como funciona (fundo escuro)
const STEPS = [
  { number: '01', title: 'Documentos', desc: 'Envio da caderneta predial e indicação da finalidade.' },
  { number: '02', title: 'Proposta', desc: 'Honorários e prazo comunicados no próprio dia, sem compromisso.' },
  { number: '03', title: 'Vistoria', desc: 'Medições e registo fotográfico executados pelo Perito.' },
  { number: '04', title: 'Relatório', desc: 'Entrega em cinco a oito dias úteis, com assinatura digital qualificada.' }
];

export const HerancasProcessSection = () => (
  <section
    className="herancas-process"
    style={{ background: 'var(--navy)', padding: '80px 5%' }}
    data-testid="herancas-process-section"
  >
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <div className="valuare-section-label valuare-label-light">Processo</div>
      <h2 className="valuare-section-title valuare-title-light">
        Do primeiro contacto <em>ao relatório</em>
      </h2>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
          gap: '0',
          borderTop: '1px solid rgba(255,255,255,0.14)',
          marginTop: '1rem'
        }}
      >
        {STEPS.map((step, i) => (
          <div
            key={step.number}
            data-testid={`herancas-process-step-${step.number}`}
            style={{
              padding: '44px 30px 40px',
              borderLeft: i === 0 ? 'none' : '1px solid rgba(255,255,255,0.14)'
            }}
          >
            <div
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '3rem',
                fontWeight: 300,
                lineHeight: 1,
                color: 'var(--gold-light)',
                marginBottom: '20px'
              }}
            >
              {step.number}
            </div>
            <h3
              style={{
                fontSize: '0.8rem',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                fontWeight: 600,
                color: 'var(--white)',
                marginBottom: '12px'
              }}
            >
              {step.title}
            </h3>
            <p style={{ fontSize: '1rem', lineHeight: 1.75, color: 'rgba(255,255,255,0.62)', fontWeight: 300, margin: 0 }}>
              {step.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
